import React, { useEffect, useRef } from 'react';
import lottie from 'lottie-web';
import liveChatbot from './live_chatbot.json';

const LiveChatbot = () => {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;

    const anim = lottie.loadAnimation({
      container: ref.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: liveChatbot,
    });

    return () => anim.destroy();
  }, []);

  return <div ref={ref} style={{ width: 200, height: 200 }} />;
};

export default LiveChatbot;
